module.exports = __webpack_public_path__ + "static/media/country_cd.fb2d8738.webp";